import { useDispatch, useSelector } from "react-redux";
import { getAllTankSensors } from "../../Api Methods/Api";
import { useEffect, useMemo, useState } from "react";
import PadlocksList from "../Padlocks/padlocksList";
import DeviceLoadingGrid from "../../components/GridList/DeviceLoadingGrid";
import StatCard from "../../components/UI/Stats/StatCard";
import mixpanel from "mixpanel-browser";

const TankSensors = () => {

    const dispatch = useDispatch();
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const apiData = {
        token,
        client
    }

    const [sensors, setSensors] = useState([])
    const [update, setUpdate] = useState(0)
    const filtering = ""
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        const HandleGetTankSensors = async () => {
            const response = await getAllTankSensors(apiData, dispatch);

            console.log(response);
            // Map the rochester/radars payload onto the field names PadlocksList's
            // shared table/search/sort logic already expects (battery, batteryReadAt, tag, uuid).
            const mapped = (response.data || []).map(sensor => ({
                ...sensor,
                deviceID: sensor.id,
                tag: sensor.tag,
                uuid: sensor.siteUUID,
                tankHeight: sensor.tank_height,
                battery: sensor.battery_percentage,
                batteryReadAt: sensor.last_seen,
            }));

            setSensors(mapped)
            setIsLoading(false)
        }

        HandleGetTankSensors();

        mixpanel.track("Tank Sensors tab visited", {
            user: localStorage.getItem('email')
        });
    }, [update])

    const linkedSensors = useMemo(() => sensors.filter(s => s.uuid != null), [sensors])
    const unlinkedSensors = useMemo(() => sensors.filter(s => s.uuid == null), [sensors])
    const criticalSensors = useMemo(() => sensors.filter(s => s.battery != null && s.battery <= 5), [sensors])
    const warningSensors = useMemo(() => sensors.filter(s => s.battery != null && s.battery > 5 && s.battery < 20), [sensors])
    const healthySensors = useMemo(() => sensors.filter(s => s.battery != null && s.battery >= 20), [sensors])

    return (
        <div style={{ width: "100%" }}>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 290px))", gap: "var(--gap-lg)", marginBottom: "8px", justifyContent: "start" }}>
                <StatCard title={"Sensors"} value={sensors.length} isLoading={isLoading} />
                <StatCard title={"Linked sensors"} value={linkedSensors.length} isLoading={isLoading} />
                <StatCard title={"Unlinked sensors"} value={unlinkedSensors.length} isLoading={isLoading} />
                <StatCard title={"Critical (<5% battery)"} value={criticalSensors.length} isLoading={isLoading} />
                <StatCard title={"Warning (<20% battery)"} value={warningSensors.length} isLoading={isLoading} />
                <StatCard title={"Healthy (>20% battery)"} value={healthySensors.length} isLoading={isLoading} />
            </div>
            <br />
            {isLoading ? (
                <div style={{ display: "flex", width: "100%" }}>
                    <DeviceLoadingGrid CardCount={20} />
                </div>
            ) : (
                <PadlocksList
                    locks={sensors}
                    filtering={filtering}
                    update={update}
                    setUpdate={setUpdate}
                    isTankSensors={true}
                />
            )}
        </div>
    );
}


export default TankSensors;
